import '../../styles/restScreens.css';
import AddressAutocomplete from '../shared/AddressAutocomplete';
import ModalSurface from '../shared/ModalSurface';
import { useState, useEffect, useMemo, useCallback } from 'react';
import PhoneInput from '../ui/PhoneInput';
import { formatPhone } from '../../lib/phone';

function EditClientDropdown({ client, onClose, onSave }) {
    const [formData, setFormData] = useState({
        firstName: client?.firstName || '',
        lastName: client?.lastName || '',
        address: client?.address || '',
        phone: client?.phone || '',
        email: client?.email || '',
        tags: client?.tags || [],
        notes: client?.notes || '',
        source: client?.source || 'Initiated by staff'
    });
     const [activeTab, setActiveTab] = useState('bookings');
    const [newTag, setNewTag] = useState('');
     const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);
    };
     const addTag = () => {
        if (newTag.trim()) {
            setFormData({...formData, tags: [...formData.tags, newTag.trim()]});
            setNewTag('');
        }
    };
     const removeTag = (tagToRemove) => {
        setFormData({...formData, tags: formData.tags.filter(t => t !== tagToRemove)});
    };
     return (
        <ModalSurface closeOnEscape={false} panelProps={{"data-m6-layout":"modals", "data-m6-component":"EditClientDropdown"}} onClose={onClose} label="Edit client" overlayClassName="fixed inset-0 bg-black bg-opacity-30 z-50" onOverlayClick={onClose} panelClassName="absolute top-0 left-0 right-0 bg-white shadow-2xl rounded-b-2xl mx-auto max-w-7xl" panelStyle={{
                    animation: 'slideDown 0.3s ease-out',
                    maxHeight: '90vh',
                    overflowY: 'auto'
                }}>
                <style>{`
                    @keyframes slideDown {
                        from { transform: translateY(-100%); opacity: 0; }
                        to { transform: translateY(0); opacity: 1; }
                    }
                `}</style>
                 {/* Header */}
                <div className="p-6 border-b border-gray-200 bg-gray-50">
                    <div className="flex justify-between items-center">
                        <div>
                            <h3 className="text-2xl font-bold text-gray-800">
                                Client / {formData.firstName} {formData.lastName}
                            </h3>
                            <div className="flex gap-3 mt-3">
                                <button className="px-4 py-2 bg-[var(--btn-fill)] text-[var(--btn-ink)] rounded hover:bg-[var(--btn-fill-hover)] text-sm">
                                    New
                                </button>
                                <button className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-50 text-sm">
                                    Take payment
                                </button>
                                <button className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-50 text-sm">
                                    Add note
                                </button>
                            </div>
                        </div>
                        <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-3xl">×</button>
                    </div>
                </div>
                 {/* Main Content */}
                <div className="grid grid-cols-3 gap-6 p-6">
                    {/* Left Panel */}
                    <div className="col-span-2 space-y-6">
                        <form onSubmit={handleSubmit} className="bg-white border border-gray-200 rounded-lg p-6 space-y-4">
                            <div className="flex items-center justify-between mb-4">
                                <h4 className="font-bold text-lg">{formData.firstName} {formData.lastName}</h4>
                                <span className="text-xl">✏️</span>
                            </div>
                            
                            <div>
                                <label className="text-sm text-gray-600 block mb-1">Client First Name:</label>
                                <input 
                                    type="text"
                                    value={formData.firstName}
                                    onChange={(e) => setFormData({...formData, firstName: e.target.value})}
                                    className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                                />
                            </div>
                            <div>
                                <label className="text-sm text-gray-600 block mb-1">Client Last Name:</label>
                                <input 
                                    type="text"
                                    value={formData.lastName}
                                    onChange={(e) => setFormData({...formData, lastName: e.target.value})}
                                    className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                                />
                            </div>
                            <div>
                                <label className="text-sm text-gray-600 block mb-1">Client Address:</label>
                                <AddressAutocomplete
                                    label="Client Address"
                                    module="crm"
                                    value={formData.address}
                                    onChange={(address) => setFormData({...formData, address})}
                                    inputClassName="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                                />
                            </div>
                            <div>
                                <label className="text-sm text-gray-600 block mb-1">Client Phone:</label>
                                <PhoneInput
                                    aria-label="Client Phone"
                                    value={formData.phone}
                                    onChange={(phone) => setFormData({...formData, phone})}
                                    className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                                />
                            </div>
                            <div>
                                <label className="text-sm text-gray-600 block mb-1">Client Email:</label>
                                <input 
                                    type="email"
                                    value={formData.email}
                                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                                    className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                                />
                            </div>
                        </form>
                         {/* Tags */}
                        <div className="bg-white border border-gray-200 rounded-lg p-4">
                            <label className="text-sm font-medium text-gray-700 mb-2 block">Tags:</label>
                            <div className="flex flex-wrap gap-2 mb-3">
                                {formData.tags.map((tag, idx) => (
                                    <span key={idx} className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-sm flex items-center gap-2">
                                        {tag}
                                        <button type="button" onClick={() => removeTag(tag)} className="hover:text-blue-900">×</button>
                                    </span>
                                ))}
                            </div>
                            <div className="flex gap-2">
                                <input 
                                    type="text"
                                    value={newTag}
                                    onChange={(e) => setNewTag(e.target.value)}
                                    onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), addTag())}
                                    placeholder="Add tag..."
                                    className="flex-1 px-3 py-2 border border-gray-300 rounded text-sm"
                                />
                                <button 
                                    type="button"
                                    onClick={addTag}
                                    className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 text-sm"
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                         {/* Tabs */}
                        <div className="bg-white border border-gray-200 rounded-lg">
                            <div className="border-b border-gray-200 flex">
                                {['conversation', 'bookings', 'payments', 'documents'].map(tab => (
                                    <button
                                        key={tab}
                                        type="button"
                                        onClick={() => setActiveTab(tab)}
                                        className={`px-6 py-3 capitalize ${
                                            activeTab === tab 
                                                ? 'border-b-2 border-[var(--accent-ink)] text-[var(--accent-ink)] font-medium' 
                                                : 'text-gray-600 hover:text-gray-800'
                                        }`}
                                    >
                                        {tab}
                                    </button>
                                ))}
                            </div>
                            <div className="p-8">
                                {activeTab === 'bookings' && (
                                    <div className="text-center py-8 text-gray-500">
                                        <div className="text-6xl mb-4">📁</div>
                                        <p>No items found</p>
                                    </div>
                                )}
                                {activeTab === 'conversation' && (
                                    <div className="text-center py-8 text-gray-500">
                                        <div className="text-6xl mb-4">💬</div>
                                        <p>No conversations yet</p>
                                    </div>
                                )}
                                {activeTab === 'payments' && (
                                    <div className="text-center py-8 text-gray-500">
                                        <div className="text-6xl mb-4">💰</div>
                                        <p>No payments recorded</p>
                                    </div>
                                )}
                                {activeTab === 'documents' && (
                                    <div className="text-center py-8 text-gray-500">
                                        <div className="text-6xl mb-4">📄</div>
                                        <p>No documents uploaded</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                     {/* Right Panel */}
                    <div className="space-y-4">
                        <div className="bg-white border border-gray-200 rounded-lg p-4">
                            <div className="flex items-center justify-between mb-4">
                                <h5 className="font-bold">Contact information</h5>
                                <span className="text-blue-600">✏️</span>
                            </div>
                             <div className="w-16 h-16 bg-[var(--btn-fill)] rounded-full flex items-center justify-center text-[var(--btn-ink)] text-2xl mb-4 mx-auto">
                                {formData.firstName[0] || 'C'}{formData.lastName[0] || 'L'}
                            </div>
                             <div className="space-y-3 text-sm">
                                <div>
                                    <div className="text-gray-600">Phone</div>
                                    <div className="font-medium">{formatPhone(formData.phone) || 'Not provided'}</div>
                                </div>
                                <div>
                                    <div className="text-gray-600">Email</div>
                                    <div className="font-medium">{formData.email || 'Not provided'}</div>
                                </div>
                                <div>
                                    <div className="text-gray-600">Address</div>
                                    <div className="font-medium">{formData.address || 'Not provided'}</div>
                                </div>
                                <div>
                                    <div className="text-gray-600">Source:</div>
                                    <div className="text-blue-600">{formData.source}</div>
                                </div>
                            </div>
                        </div>
                         <div className="bg-white border border-gray-200 rounded-lg p-4">
                            <h5 className="font-bold mb-2">Payment Method (0)</h5>
                            <p className="text-sm text-gray-600 mb-3">No payment method saved</p>
                            <button type="button" className="text-blue-600 hover:text-blue-700 text-sm">+ Add new</button>
                        </div>
                         {/* Communications Box - Fills remaining space */}
                        <div className="bg-white border border-gray-200 rounded-lg p-4 flex-1">
                            <h5 className="font-bold mb-3">Communications</h5>
                            <div className="bg-gray-50 border border-gray-300 rounded-lg p-6 h-full min-h-[300px]">
                                <div className="text-center text-gray-500">
                                    <div className="text-4xl mb-3">📧</div>
                                    <p className="text-sm font-medium mb-1">Future Messaging & Email</p>
                                    <p className="text-xs">Send messages and emails directly to clients</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                 {/* Footer */}
                <div className="p-6 border-t border-gray-200 bg-gray-50 flex justify-end gap-3">
                    <button 
                        type="button"
                        onClick={onClose}
                        className="px-6 py-2 border border-gray-300 rounded hover:bg-gray-50"
                    >
                        Cancel
                    </button>
                    <button 
                        onClick={handleSubmit}
                        className="px-6 py-2 bg-[var(--btn-fill)] text-[var(--btn-ink)] rounded hover:bg-[var(--btn-fill-hover)]"
                    >
                        Save Changes
                    </button>
                </div>
            </ModalSurface>
    );
}


export default EditClientDropdown;
